import React from 'react';
import RapGallery from './RapGallery';
import * as S from './styles';

const Main: React.FC = () => {
  return (
    <S.Container>
      <S.Header>
        <S.HighlightMobile />
      </S.Header>
      <S.Content>
        <S.Text>
          Adentrar o universo do rap é encontrar um panorama diversificado de
          sonoridades, estilos de interpretação e eixos temáticos. Desde o
          primeiro sucesso do gênero, “Rappers delight”, da Sugarhill Gang, de
          1979, ele se desenvolveu em direções múltiplas, aceitou influências
          que vão do jazz à psicodelia, retratou amor e raiva. O que permanece
          intacto é sua essência como voz e expressão das periferias do planeta.
          Aqui, explicamos alguns dos termos frequentes usados para falar do
          gênero hoje e que você irá encontrar nesta edição dedicada ao rap
          nacional.
        </S.Text>
        <S.Author>POR CAMILO ROCHA</S.Author>
        <RapGallery />
      </S.Content>
    </S.Container>
  );
};

export { Main };
